"use client"

import { createContext, useContext, useState, useEffect, FC, ReactNode } from 'react'

export type Lang = 'uk' | 'fr'

const STORAGE_KEY = 'obelisk_lang'

interface LangCtx {
  lang: Lang
  setLang: (l: Lang) => void
}

const LanguageContext = createContext<LangCtx>({ lang: 'uk', setLang: () => {} })

export const useLanguage = () => useContext(LanguageContext)

export const LanguageProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [lang, setLangState] = useState<Lang>('uk')

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY) as Lang | null
    if (stored === 'uk' || stored === 'fr') {
      setLangState(stored)
      return
    }
    fetch('https://ipapi.co/json/')
      .then((r) => r.json())
      .then((data) => {
        if (data?.country_code === 'FR') setLangState('fr')
      })
      .catch(() => {})
  }, [])

  const setLang = (l: Lang) => {
    setLangState(l)
    localStorage.setItem(STORAGE_KEY, l)
  }

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  )
}
